import * as React from "react";

export default () => {
  return <div>Konfigurera kolumner som ska importeras</div>;
};
